import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import PageHeader from '@common/PageHeader'
import { RouterView } from '@merchant-backend/common-components'
import 'antd4/lib/grid/style/index.css'
import { Tag } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { formItemLayout } from '../../constants'

const FormItem = Form.Item
const CheckableTag = Tag.CheckableTag

@inject('store')
@observer
class TagsInfo extends Component {
  render() {
    const { tag_list, changeTagValue } = this.props.store
    if (isEmpty(tag_list)) {
      return null
    }

    return (
      <RouterView
        domId="main-content2"
        title="案例标签"
        bodyStyle={{ padding: '24px' }}
        viewStyle={{ margin: '0 20px 4px' }}
        titleStyle={{ height: 48, padding: '0 24px' }}
      >
        <div style={{ margin: '0 0 44px 0' }}>
          <PageHeader
            style={{ color: '#333333' }}
            title="标签会影响在首页、频道、搜索等页面的推荐，更精准的设置标签，快速获得更高的曝光和转化。"
          />
        </div>
        {tag_list.map((item, i) => {
          return (
            <FormItem
              className={'tags'}
              label={
                item.required == 1 ? (
                  <span className="required">{item.name}</span>
                ) : (
                  <span>{item.name}</span>
                )
              }
              {...formItemLayout}
              key={i}
            >
              {item.children &&
                item.children.map((child, j) => {
                  return (
                    <CheckableTag
                      key={j}
                      checked={child.isActive}
                      onChange={flag => changeTagValue(i, j, flag, item)}
                    >
                      {child.name}
                    </CheckableTag>
                  )
                })}
              <div>最多选{item?.quantity_range?.[1] || 1}个</div>
            </FormItem>
          )
        })}
      </RouterView>
    )
  }
}

export default TagsInfo
